import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E取込分類 } from '@/openapi/enum';

import C勘定科目ListEditItemButtons from '@/components/勘定科目/listEdit/button/item/勘定科目ListEditItemButtons.vue';
import C差異分析MonthlyTable from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/差異分析/monthlyTable/差異分析MonthlyTable.vue';
import C差異分析Header from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/差異分析/差異分析Header/差異分析Header.vue';

import PlbscfKeystrokeInputableTextMixin, {
  PlbscfInputableTextId,
} from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';

import { MONTHS_OF_YEAR } from '@/classes/common/Constants';
import AbstractPlbscfService from '@/classes/service/AbstractPlbscfService';
import 差異分析Service, { 差異分析, 月次推移ListItem } from '@/classes/service/モニタリング/差異分析Service';

export default mixins(PlbscfKeystrokeInputableTextMixin, PlbscfKeystrokeResetMixin).extend({
  name: 'M差異分析Mixin',

  props: {
    service: {
      type: Object as PropType<差異分析Service>,
      required: true,
    },
    差異分析: {
      type: Object as PropType<差異分析>,
      required: true,
    },
  },

  components: {
    C勘定科目ListEditItemButtons,
    C差異分析MonthlyTable,
    C差異分析Header,
  },

  data(): {
    e取込分類: typeof E取込分類;
  } {
    return {
      e取込分類: E取込分類,
    };
  },

  methods: {
    createMapBy月次推移List(list: 月次推移ListItem[]): PlbscfInputableTextId[][] {
      const map: PlbscfInputableTextId[][] = [];
      list.forEach((l, listItemIndex) => {
        const ids: PlbscfInputableTextId[] = [];
        if (l.value?.実績 !== undefined && AbstractPlbscfService.isEditable(l.config, l.value.実績)) {
          for (let monthIndex = 0; monthIndex < MONTHS_OF_YEAR; monthIndex++) ids.push({ listItemIndex, monthIndex });
        }
        if (ids.length > 0) map.push(ids);
      });
      return map;
    },
  },
});
